import React from "react";

interface FamilySituationBadgeProps {
  situation: "SINGLE" | "MARRIED" | "DIVORCED" | "WIDOWED" | "SEPARATED" | "COHABITING" | "OTHER" | string;
  text?: string;
  className?: string;
  size?: "sm" | "mid" | "lg";
}

const FAMILY_SITUATION_COLORS: Record<string, "success" | "warning" | "danger" | "primary" | "info" | "secondary"> = {
  SINGLE: "info",       
  MARRIED: "success",   
  DIVORCED: "warning",  
  WIDOWED: "danger",    
  SEPARATED: "warning", 
  COHABITING: "primary",
  OTHER: "secondary",    
};

const FAMILY_SITUATION_ICONS: Record<string, string> = {
  SINGLE: "ti ti-user",              
  MARRIED: "ti ti-heart",           
  DIVORCED: "ti ti-heart-off",      
  WIDOWED: "ti ti-cross",           
  SEPARATED: "ti ti-separator",     
  COHABITING: "ti ti-users",        
  OTHER: "ti ti-help",               
};

const FAMILY_SITUATION_LABELS: Record<string, string> = {
  SINGLE: "Single",
  MARRIED: "Married",
  DIVORCED: "Divorced",
  WIDOWED: "Widowed",
  SEPARATED: "Separated",
  COHABITING: "Cohabiting",
  OTHER: "Other",
};

const FamilySituationBadge: React.FC<FamilySituationBadgeProps> = ({ 
  situation,
  text,
  className = "",
  size = "mid"
}) => {
  const sizeStyles = {
    sm: { fontSize: '0.75rem', iconSize: '1rem', padding: 'px-2 py-1' },
    mid: { fontSize: '0.875rem', iconSize: '1.2rem', padding: 'px-3 py-1' },
    lg: { fontSize: '1rem', iconSize: '1.5rem', padding: 'px-4 py-2' },
  }[size];

  const badgeColor = FAMILY_SITUATION_COLORS[situation] || "secondary";
  const badgeIcon = FAMILY_SITUATION_ICONS[situation] || "ti ti-help";
  const displayText = text || FAMILY_SITUATION_LABELS[situation] || situation;

  return (
    <span 
      className={`badge badge-soft-${badgeColor} d-inline-flex align-items-center ${sizeStyles.padding} ${className}`}
      style={{ fontSize: sizeStyles.fontSize }}
    >
      <i 
        className={`${badgeIcon} me-1`} 
        style={{ fontSize: sizeStyles.iconSize }}
      ></i>
      {displayText}
    </span>
  );
};

export default FamilySituationBadge;